import TitlePage from "../../components/titlePage/titlePage";
import styles from "./correosElectronicos.module.css";
import ApiFetch from "../../utils/fetch";
import { useState, useEffect, useContext } from "react";
import SwalAlert from "../../utils/swalAlert";
import Loading from "../../components/loading/loading";
import { useNavigate } from "react-router-dom";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import PhoneIcon from "@mui/icons-material/Phone";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import WifiIcon from "@mui/icons-material/Wifi";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import {
  Button,
  Checkbox,
  TextField,
  Alert,
  FormControlLabel,
} from "@mui/material";
import { AppContext } from "../../context/context";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import PhoneAndroidRoundedIcon from "@mui/icons-material/PhoneAndroidRounded";
import Input from "../../components/input/input";
import ReturnBackButton from "../../components/returnBackButton/ReturnBackButton";

const alert = new SwalAlert();
const fetch = new ApiFetch();

const CorreosElectronicos = ({ setShowModalProfile, showModalProfile }) => {
  const { sessionExpired } = useContext(AppContext);
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState("");
  const [arrayIdCtaFact, setArrayIdCtaFact] = useState([]);
  const [newEmail, setNewEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [codPais, setCodPais] = useState("");
  const [codArea, setCodArea] = useState("");
  const [celular, setCelular] = useState("");
  const [disabledButton, setDisabledButton] = useState(true);
  const [subscribe, setSubscribe] = useState(false);

  const getServices = async () => {
    try {
      setLoading(<Loading />);
      const data = await fetch.GET("/services");
      setLoading("");
      const status = data?.status;
      const message = data?.message;
      if (status === 401) {
        sessionExpired(message);
        return;
      }
      //Si el asociado no tiene servicios, la API puede devolver body vacío o nulo.
      const listaServicios = Array.isArray(data?.body) ? data.body : [];
      setServices(listaServicios);
      const cliente = listaServicios[0];
      setCodPais(cliente?.CelularCodPais || "");
      setCodArea(cliente?.CelularCodArea || "");
      setCelular(cliente?.CelularNumero || "");
      setSubscribe(cliente?.Suscripto || false);
    } catch (error) {
      //Un error de red no es una sesión vencida: no se borra la sesión.
      setLoading("");
      setServices([]);
      alert.error(
        "No fue posible consultar sus datos, intente nuevamente más tarde.",
      );
    }
  };

  const handleNewEmailChange = (e) => {
    const email = e.target.value;
    setNewEmail(email);
    const emailRegex = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;
    if (!email.length > 0) {
      setEmailError("");
      return;
    }
    if (!emailRegex.test(email)) {
      setEmailError("El correo electrónico no es válido");
    } else {
      setEmailError("");
    }
  };

  const updateEmail = async () => {
    try {
      if (
        (!arrayIdCtaFact?.length > 0 || !newEmail || emailError) &&
        (!codArea || !codPais || !celular)
      ) {
        return;
      }
      const body = JSON.stringify({
        idCtaFact: arrayIdCtaFact,
        mail: newEmail,
        codPais: codPais.toString(),
        codArea: codArea.toString(),
        celular: celular.toString(),
        subscribe,
      });
      setLoading(<Loading />);
      const data = await fetch.POST(body, "/updateEmail");
      setLoading("");
      const status = data?.status;
      const message = data?.message;
      switch (status) {
        case 201:
          setNewEmail("");
          setArrayIdCtaFact([]);
          setServices([]);
          //Cierro el modal cuando se actualizan los datos.
          if (setShowModalProfile) {
            setShowModalProfile(false);
          }
          alert.success(message);
          await getServices();
          break;
        case 401:
          sessionExpired(message);
          break;
        default:
          alert.error(message);
          break;
      }
    } catch (error) {
      setLoading("");
      alert.error(
        "No fue posible actualizar los datos, intente nuevamente más tarde.",
      );
    }
  };

  const handleCheckboxChange = (event) => {
    const { IdCtaFact } = JSON.parse(event.target.value);
    if (event.target.checked) {
      if (!arrayIdCtaFact.includes(IdCtaFact)) {
        setArrayIdCtaFact((prevArray) => [...prevArray, IdCtaFact]);
      }
    } else {
      setArrayIdCtaFact((prevArray) =>
        prevArray.filter((item) => item !== IdCtaFact),
      );
    }
  };

  useEffect(() => {
    getServices();
  }, []);

  useEffect(() => {
    if (codArea && codPais && celular) {
      setDisabledButton(false);
    } else {
      if (arrayIdCtaFact?.length > 0 && newEmail && !emailError) {
        setDisabledButton(false);
      } else {
        setDisabledButton(true);
      }
    }
  }, [codArea, codPais, celular, arrayIdCtaFact, newEmail, emailError]);

  return (
    <div className={styles.container}>
      {!showModalProfile && <ReturnBackButton />}
      <TitlePage idTramite={9} />

      <Alert severity="success" icon={<PhoneAndroidRoundedIcon />}>
        Número de celular:
      </Alert>
      <FormControlLabel
        onChange={() => setSubscribe(!subscribe)}
        control={<Checkbox checked={subscribe} />}
        label="Deseo recibir notificaciones como avisos de deuda y cortes a mi número de Whatsapp."
      />

      <div className={styles.phoneContainer}>
        <div className={styles.celularCodPais}>
          <Input
            error={codPais ? false : true}
            helperText="ej:54"
            value={codPais}
            setValue={setCodPais}
            size="small"
            label="Pais"
            type="number"
            maxLength={3}
          />
        </div>
        <div className={styles.celularCodArea}>
          <Input
            error={codArea ? false : true}
            helperText="ej:3525"
            value={codArea}
            setValue={setCodArea}
            size="small"
            label="Área"
            type="number"
            maxLength={4}
          />
        </div>
        <div className={styles.celularNumero}>
          <Input
            error={celular ? false : true}
            helperText="ej:123456"
            value={celular}
            setValue={setCelular}
            size="small"
            label="Celular"
            type="number"
            maxLength={7}
          />
        </div>
      </div>

      <Alert severity="success" icon={<EmailRoundedIcon />}>
        Correos electrónicos:
      </Alert>
      <TextField
        size="small"
        label="Ingrese nuevo Correo Electrónico"
        value={newEmail}
        onChange={handleNewEmailChange}
        error={!!emailError}
        helperText={emailError}
      />
      <span>
        A continuación, seleccione los servicios para los que desea actualizar
        con su nuevo correo.
      </span>
      <div className={styles.tableContainer}>
        {services?.length > 0 ? (
          <table className={styles.tableServices}>
            <thead>
              <tr>
                <th></th>
                <th>Servicio</th>
                <th>Email</th>
                <th>Domicilio</th>
              </tr>
            </thead>
            {services?.map((service, i) => {
              const idService = service?.IdServicio;
              let icon;
              switch (idService) {
                case 1:
                  icon = (
                    <ElectricBoltIcon
                      style={{ color: "#F1C40F", marginRight: 5 }}
                    />
                  );
                  break;
                case 2:
                  icon = (
                    <WaterDropIcon
                      style={{ color: "#5DADE2", marginRight: 5 }}
                    />
                  );
                  break;
                case 3:
                  icon = (
                    <PhoneIcon style={{ color: "#CA6F1E", marginRight: 5 }} />
                  );
                  break;
                case 5:
                  icon = (
                    <WifiIcon style={{ color: "#5D6D7E", marginRight: 5 }} />
                  );
                  break;
                case 30:
                  icon = (
                    <LiveTvIcon style={{ color: "#17A589", marginRight: 5 }} />
                  );
                  break;
                default:
                  break;
              }
              return (
                <tbody key={i} style={{ fontSize: 12, wordWrap: "break-word" }}>
                  <tr>
                    <td>
                      <Checkbox
                        size="small"
                        color="success"
                        value={JSON.stringify({ IdCtaFact: service.IdCtaFact })}
                        onChange={handleCheckboxChange}
                        aria-label="option 1"
                      />
                    </td>
                    <td>
                      {icon}
                      {service?.Servicio}
                    </td>
                    <td>{service?.Mail}</td>
                    <td>{service?.Domicilio}</td>
                  </tr>
                </tbody>
              );
            })}
          </table>
        ) : (
          "No se encontraron servicios."
        )}
      </div>

      {loading}
      {services?.length > 0 && (
        <div className={styles.buttonContainer}>
          <Button
            onClick={() => updateEmail()}
            disabled={disabledButton}
            size="small"
            color="success"
            variant="contained"
          >
            Actualizar Datos
          </Button>
        </div>
      )}
    </div>
  );
};

export default CorreosElectronicos;
